import React from "react";
import { styled, fontSizes } from "@iventis/styles";
import { Theme } from "@emotion/react";

interface KeyboardShortcutToolTipComponentProps {
    header: string;
    shortcut?: string;
}

export const KeyboardShortcutToolTipComponent: React.FC<KeyboardShortcutToolTipComponentProps> = ({ header, shortcut }) => (
    <KeyboardShortcutToolTipContainer $shortcut={shortcut}>
        <StyledHeader>{header}</StyledHeader>
        {shortcut && (
            <>
                <StyledSeparator role="separator" />
                <StyledKeyboardShortCut>{shortcut}</StyledKeyboardShortCut>
            </>
        )}
    </KeyboardShortcutToolTipContainer>
);

const KeyboardShortcutToolTipContainer = styled.div<{ $shortcut?: string }>`
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: ${({ $shortcut }) => ($shortcut ? "100px" : "none")};
    padding: 0.3125em;
`;

const StyledHeader = styled.div`
    font-weight: 400;
    font-size: ${fontSizes.small};
    line-height: 20px;
`;
const StyledKeyboardShortCut = styled.span`
    font-weight: 400;
    font-size: 0.625em;
    line-height: 20px;
    color: ${({ theme }: { theme: Theme }) => theme.shades.darkBorder};
`;

const StyledSeparator = styled.div`
    height: 1px;
    width: 100%;
    background-color: ${({ theme }: { theme: Theme }) => theme.secondaryColors.mediumAccent};
`;
